import AxiosService from './axios.service';
import { AxiosResponse } from 'axios';
import { CreateOrganizationDto, Organization, UpdateOrganizationDto } from './types/types';

export class OrganizationsService {
  static async create(dto: CreateOrganizationDto): Promise<Organization> {
    const response: AxiosResponse<Organization> = await AxiosService.post('/organizations', dto);
    return response.data;
  }

  static async findAll(): Promise<Organization[]> {
    const response: AxiosResponse<Organization[]> = await AxiosService.get('/organizations');
    return response.data;
  }

  static async findOne(id: number): Promise<Organization> {
    const response: AxiosResponse<Organization> = await AxiosService.get(`/organizations/${id}`);
    return response.data;
  }

  static async update(id: number, dto: UpdateOrganizationDto): Promise<Organization> {
    const response: AxiosResponse<Organization> = await AxiosService.patch(`/organizations/${id}`, dto);
    return response.data;
  }

  static async remove(id: number): Promise<void> {
    await AxiosService.delete(`/organizations/${id}`);
  }

  static async addUsuario(id: number, usuarioRut: string): Promise<Organization> {
    const response: AxiosResponse<Organization> = await AxiosService.post(`/organizations/${id}/usuarios`, {
      usuarioRut,
    });
    return response.data;
  }

  static async removeUsuario(id: number, usuarioRut: string): Promise<Organization> {
    const response: AxiosResponse<Organization> = await AxiosService.delete(
      `/organizations/${id}/usuarios/${usuarioRut}`,
    );
    return response.data;
  }
}
